
$('.provariant').change(function () {
    var vid = $(this).val();
    $(this).parents('.pro_content').find('[name="id"]').val(vid)
})
 $('.marqslide').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    touchMove: false,
    autoplaySpeed: 0,
    draggable: false,
    swipeToSlide: false,
    speed: 8000,
    variableWidth: true,
    pauseOnHover: false,
    cssEase: 'linear'
});

function addtoCart(id) {
  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {id:id,quantity:1},
      success: function(){
          window.location.href="/checkout";
      }
  });
}

$('.donatebtn').click(function(){
  var id = $('select#donation').val();
  addtoCart(id)
})
 $(document).on('click','.add_to_cart',function(){
      var id = $(this).parents('.atc_button').find('[name="id"]').val();
      addtoCart(id)
  })

$('.variant-item').click(function(){
  $(this).addClass('selected').siblings().removeClass('selected');
})

$('.customaddcart').click(function(){
   var id = $('.variant-item.selected').attr('id');
   addtoCart(id)
})

$('.winslider').slick({
  infinite: true,
  centerMode: true,
  slidesToShow: 1,
  centerPadding: '260px',
  slidesToScroll: 1.3,
  prevArrow: $(".slider-left"),
  nextArrow: $(".slider-right"),
  responsive: [
    {
      breakpoint: 1366,
      settings: {
        centerPadding: '50px',
      }    
    },
    {
      breakpoint: 1024,
      settings: {
        centerPadding: '100px',
      }
    },
    {
      breakpoint: 749,
      settings: {
       centerPadding: '100px',
      }
    },
      {
        breakpoint: 480,
        settings: {
         centerPadding: '30px',
        }
      }
  ]
});

// $(document).ready(function(){
//   $('.fundslider-slide').slick({
//     infinite: true,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     autoplay: {{ section.settings.autoplay_enabled | json }},
//     autoplaySpeed: {{ section.settings.autoplay_speed | json }},
//     prevArrow: $(".fund-left"),
//     nextArrow: $(".fund-right"),
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 2,
//         }
//       },
//       {
//         breakpoint: 749,
//         settings: {
//           slidesToShow: 2,
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//         }
//       }
//     ]
//   });


$('.vs-slider').slick({
  autoplay: true,
  autoplaySpeed: 3000,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: `<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.46875 0.46875L0.75 6.46875C0.604167 6.61458 0.53125 6.78125 0.53125 6.96875C0.53125 7.15625 0.604167 7.33333 0.75 7.5L6.46875 13.4688C6.80208 13.7604 7.15625 13.7708 7.53125 13.5C7.82292 13.1458 7.82292 12.7917 7.53125 12.4375L2.28125 6.9375L7.53125 1.53125C7.82292 1.15625 7.82292 0.802083 7.53125 0.46875C7.15625 0.177083 6.80208 0.177083 6.46875 0.46875Z" fill="#192853"/>
    </svg>`,
  nextArrow: `<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.53125 0.46875L7.25 6.46875C7.39583 6.61458 7.46875 6.78125 7.46875 6.96875C7.46875 7.15625 7.39583 7.33333 7.25 7.5L1.53125 13.4688C1.19792 13.7604 0.84375 13.7708 0.46875 13.5C0.177083 13.1458 0.177083 12.7917 0.46875 12.4375L5.71875 6.9375L0.46875 1.53125C0.177083 1.15625 0.177083 0.802083 0.46875 0.46875C0.84375 0.177083 1.19792 0.177083 1.53125 0.46875Z" fill="#192853"/>
</svg>`,
  
});
